import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BackendMessageTranslationService {
  private messageMappings: { [key: string]: string } = {
    // Authentication errors
    'Invalid credentials': 'login_invalid_credentials',
    'User not found': 'login_user_not_found',
    'Account locked': 'login_account_locked',
    'Password expired': 'login_password_expired',

    // Success messages
    'Password reset successful': 'password_reset_successful',
    'Password changed successfully': 'password_change_successful',
    'Password reset instructions sent': 'password_reset_email_sent',
    'Client reinstated successfully': 'client_reinstated_successfully',
    'Client enabled successfully': 'client_enabled_successfully',
    'Client deleted successfully': 'client_deleted_successfully',
    'Client disabled successfully': 'client_disabled_successfully',
    'Client rejected successfully': 'client_rejected_successfully',
    'Client approved successfully': 'client_approved_successfully',
    'Document added successfully': 'document_added_successfully',
    'Corporate Client rejected successfully':
      'corporate_client_rejected_successfully',
    'Corporate Client approved successfully':
      'corporate_client_approved_successfully',
    'Corporate Client reinstated successfully':
      'corporate_client_reinstated_successfully',
    'Corporate Client deleted successfully':
      'corporate_client_deleted_successfully',
    'Corporate Client disabled successfully':
      'corporate_client_disabled_successfully',
    'Corporate client have been approved successfully':
      'corporate_client_approved_successfully',
    'Corporate client have been rejected':
      'corporate_client_rejected_successfully',
    'Corporate client have been disabled':
      'corporate_client_disabled_successfully',
    'Corporate client have been enabled':
      'corporate_client_enabled_successfully',
    'Corporate client have been activated':
      'corporate_client_activated_successfully',
    'Corporate client have been reversed back to pending':
      'corporate_client_reversed_to_pending_successfully',
    'Corporate client have been reverted to pending':
      'corporate_client_reverted_to_pending_successfully',
    'Document saved successfully': 'document_saved_successfully',
    'Guarantor enabled successfully': 'guarantor_enabled_successfully',
    'Guarantor disabled successfully': 'guarantor_disabled_successfully',
    'Guarantor approved successfully': 'guarantor_approved_successfully',
    'Guarantor rejected successfully': 'guarantor_rejected_successfully',
    'Guarantor reinstated successfully': 'guarantor_reinstated_successfully',
    'Guarantor deleted successfully': 'guarantor_deleted_successfully',
    'Loan approved successfully': 'loan_approved_successfully',
    'Loan rejected successfully': 'loan_rejected_successfully',
    'Loan reinstated successfully': 'loan_reinstated_successfully',
    'Loan deleted successfully': 'loan_deleted_successfully',
    'Loan disabled successfully': 'loan_disabled_successfully',
    'Loan enabled successfully': 'loan_enabled_successfully',
    'Loan authorized successfully': 'loan_authorized_successfully',
    'Loan disbursed successfully': 'loan_disbursed_successfully',
    'Loan written off successfully': 'loan_written_off_successfully',
    'Loan cancelled successfully': 'loan_cancelled_successfully',
    'Loan reversed successfully': 'loan_reversed_successfully',
    'Loan cancellation requested successfully':
      'loan_cancellation_requested_successfully',
    'Loan Interest waived successfully': 'loan_interest_waived_successfully',
    'Account rejected successfully': 'account_rejected_successfully',
    'Account approved successfully': 'account_approved_successfully',
    'Transfer to Own Account Successful': 'transfer_to_own_account_successful',
    'Transfer to Third Party Successful': 'transfer_to_third_party_successful',
    'Deposit Successful': 'deposit_successful',
    'Withdrawal Successful': 'withdrawal_successful',
    'Deposit Reversed Successfully': 'deposit_reversed_successfully',
    'Withdrawal Reversed Successfully': 'withdrawal_reversed_successfully',
    'Area approved successfully': 'area_approved_successfully',
    'Area rejected successfully': 'area_rejected_successfully',
    'Area disabled successfully': 'area_disabled_successfully',
    'Area enabled successfully': 'area_enabled_successfully',
    'Area reinstated successfully': 'area_reinstated_successfully',
    'Area deleted successfully': 'area_deleted_successfully',
    'Area created successfully': 'area_created_successfully',
    'Area updated successfully': 'area_updated_successfully',
    'Branch approved successfully': 'branch_approved_successfully',
    'Branch updated successfully': 'branch_updated_successfully',
    'Branch deleted successfully': 'branch_deleted_successfully',
    'Branch disabled successfully': 'branch_disabled_successfully',
    'Branch enabled successfully': 'branch_enabled_successfully',
    'Branch reinstated successfully': 'branch_reinstated_successfully',
    'Branch rejected successfully': 'branch_rejected_successfully',
    'Branch created successfully': 'branch_created_successfully',
    'Editted charge approved successfully':
      'editted_charge_approved_successfully',
    'Editted charge rejected successfully':
      'editted_charge_rejected_successfully',
    'Deposit product approved successfully':
      'deposit_product_approved_successfully',
    'Deposit product rejected successfully':
      'deposit_product_rejected_successfully',
    'Editted deposit product approved successfully':
      'editted_deposit_product_approved_successfully',
    'Editted deposit product rejected successfully':
      'editted_deposit_product_rejected_successfully',
    'Loan product approved successfully': 'loan_product_approved_successfully',
    'Loan product rejected successfully': 'loan_product_rejected_successfully',
    'Editted loan product approved successfully':
      'editted_loan_product_approved_successfully',
    'Editted loan product rejected successfully':
      'editted_loan_product_rejected_successfully',
    'Default payment gateway updated successfully':
      'default_payment_gateway_updated_successfully',
    'Payment gateway updated successfully':
      'payment_gateway_updated_successfully',
    'Payment gateway deleted successfully':
      'payment_gateway_deleted_successfully',
    'Setup saved successfully': 'setup_saved_successfully',
    'Payment gateway configured successfully. Changes will be applied within 24 hours':
      'payment_gateway_configured_successfully',
    'Your custom payment gateway {gatewayName} has been submitted for review. Please allow up to 24 hours for processing':
      'your_custom_payment_gateway_has_been_submitted_for_review',
    'Role updated successfully': 'role_updated_successfully',
    'Dashboard viewing right updated successfully':
      'dashboard_viewing_right_updated_successfully',
    'Role created successfully': 'role_created_successfully',
    '{templateName} modified successfully': 'template_modified_successfully',
    '{templateName} created successfully': 'template_created_successfully',
    'Year End Closure initiated successfully': 'year_end_closure_initiated_successfully',
    'User logged out successfully': 'user_logged_out_successfully',

    // Validation messages
    'Kindly enter your old password': 'validation_enter_old_password',
    'Password should contain a minimum of six character':
      'validation_password_minimum_six',
    'Passwords do not match': 'validation_passwords_do_not_match',
    'Account Officer is required': 'validation_account_officer_required',
    'Failed to load dependencies': 'failed_to_load_dependencies',
    'One or more selected client(s) do not have a loan officer':
      'one_or_more_selected_clients_do_not_have_a_loan_officer',
    'Failed to load client data': 'failed_to_load_client_data',
    'Basic section required': 'basic_section_required',
    'Phone number in use by another guarantor':
      'phone_number_in_use_by_another_guarantor',
    'Failed! Please check the account number and try again.':
      'failed_to_load_account_number',
    'No type selected': 'no_type_selected',
    'Rate is required': 'rate_is_required',

    // Notification messages
    'An error occured when deleting notification.': 'notification_delete_error',
    'Client awaiting KYC completion': 'client_awaiting_kyc_completion',
    'Error preparing draft for submission':
      'error_preparing_draft_for_submission',
    'Failed to save draft': 'failed_to_save_draft',
    'An error occurred while saving draft':
      'an_error_occurred_while_saving_draft',
    'Company details update method not available':
      'company_details_update_method_not_available',
    'Account signatories update method not available':
      'account_signatories_update_method_not_available',
    'Account mandate update method not available':
      'account_mandate_update_method_not_available',
    'Agreements update method not available':
      'agreements_update_method_not_available',
    'Declaration update method not available':
      'declaration_update_method_not_available',
    'Documents update method not available':
      'documents_update_method_not_available',
    'User not authorized to approve edit':
      'user_not_authorized_to_approve_edit',
    'User not authorized to reject edit': 'user_not_authorized_to_reject_edit',
    'Unable to load previous signature': 'unable_to_load_previous_signature',
    'No previous signature available': 'no_previous_signature_available',
    'Failed to download PDF': 'failed_to_download_pdf',
    'PDF download started': 'pdf_download_started',
    'No previous document available': 'no_previous_document_available',
    'Unable to load previous document': 'unable_to_load_previous_document',
    'File size exceeds 5MB limit': 'file_size_exceeds_5mb_limit',
    'Please fill all required fields before adding a document':
      'please_fill_all_required_fields_before_adding_a_document',
    'Failed to load client comparison data':
      'failed_to_load_client_comparison_data',
    'An error occurred while processing the action':
      'an_error_occurred_while_processing_the_action',
    'No guarantor available for this loan':
      'no_guarantor_available_for_this_loan',
    'Append witness name': 'append_witness_name',
    'Upload signature': 'upload_signature',
    'Append spouse name': 'append_spouse_name',
    'Guarantor enabled to guarantee multiple loans':
      'guarantor_enabled_to_guarantee_multiple_loans',
    'Guarantor disabled to guarantee multiple loans':
      'guarantor_disabled_to_guarantee_multiple_loans',
    'No account selected': 'no_account_selected',
    'No GL account selected': 'no_gl_account_selected',
    'No fund source selected': 'no_fund_source_selected',
    'Applied to {count} matching item(s) in same branch':
      'applied_to_matching_items_in_same_branch',
    'No empty dropdowns found in the same branch with this GL account available':
      'no_empty_dropdowns_found_in_the_same_branch_with_this_gl_account_available',
    'Please select a GL account before applying':
      'please_select_a_gl_account_before_applying',
    'Select a GL account to see available matches':
      'select_a_gl_account_to_see_available_matches',
    'No other empty loan accounts in the same branch have access to this GL account':
      'no_other_empty_loan_accounts_in_the_same_branch_have_access_to_this_gl_account',
    'Automatically apply this account to {matchCount} empty loan account(s) in the same branch that have access to it':
      'automatically_apply_this_account_to_empty_loan_account_in_the_same_branch_that_have_access_to_it',
    'Please select a fund source before applying':
      'please_select_a_fund_source_before_applying',
    'One or more selected loan(s) do not have a designated Fund source':
      'one_or_more_selected_loans_do_not_have_a_designated_fund_source',
    'One or more selected loan(s) do not have a designated repayment account':
      'one_or_more_selected_loans_do_not_have_a_designated_repayment_account',
    'No account name found. Try again.': 'no_account_name_found',
    'Insufficient balance. Available: {balance}':
      'insufficient_balance_available',
    'Failed to update default payment gateway':
      'failed_to_update_default_payment_gateway',
    'Invalid gateway ID': 'invalid_gateway_id',
    'Payment gateway not found': 'payment_gateway_not_found',
    'Failed to fetch payment gateway details':
      'failed_to_fetch_payment_gateway_details',
    'Failed to load selected country data':
      'failed_to_load_selected_country_data',
    'Failed to load states for selected country':
      'failed_to_load_states_for_selected_country',
    'Failed to load countries': 'failed_to_load_countries',
    'Failed to load payment gateways': 'failed_to_load_payment_gateways',
    'No client data found. Kindly fill form':
      'no_client_data_found_kindly_fill_form',
    'Failed to load client data. Please try again':
      'failed_to_load_client_data',
    'Please select a country before saving':
      'please_select_a_country_before_saving',
    'Failed to save setup': 'failed_to_save_setup',
    'Are you sure you want to delete this payment gateway?':
      'are_you_sure_you_want_to_delete_this_payment_gateway',
    'Failed to delete payment gateway': 'failed_to_delete_payment_gateway',
    'Payment gateway configured successfully':
      'payment_gateway_configured_successfully',
    'Failed to load payment gateway': 'failed_to_load_payment_gateway',
    'Failed to configure payment gateway':
      'failed_to_configure_payment_gateway',
    'File size cannot exceed 5MB': 'file_size_cannot_exceed_5mb',
    'File dimension should be 36px by 36px or less':
      'file_dimension_should_be_36px_by_36px_or_less',
    'File dimension should be 500px by 500px or less':
      'file_dimension_should_be_500px_by_500px_or_less',
    'File not an image. Please upload a file': 'file_not_an_image',
    'An error occured when deleting notification': 'an_error_occured_when_deleting_notification',

    // General errors
    'Server error': 'server_error',
    'Network error': 'network_error',
    'Unauthorized access': 'unauthorized_access',
    'Something went wrong': 'something_went_wrong',

    // Add more mappings as needed
  };

  /**
   * Get translation key for backend message
   * @param backendMessage The message from backend
   * @returns Translation key or original message if no mapping found
   */
  getTranslationKey(backendMessage: string): string {
    const translationKey =
      this.messageMappings[backendMessage] || backendMessage;

    return translationKey;
  }

  /**
   * Add new message mapping
   * @param backendMessage The backend message
   * @param translationKey The translation key
   */
  addMessageMapping(backendMessage: string, translationKey: string): void {
    this.messageMappings[backendMessage] = translationKey;
  }
}
